import Cruise from '../types/Cruise'
import Ship from '../types/Ship'
import Stopover from '../types/Stopover'

export function isShip(item: Ship | Stopover | null): item is Ship {
  return item !== null && (item as Ship).code !== undefined
}

export function isStopover(item: Ship | Stopover | null): item is Stopover {
  return item !== null && (item as Stopover).port_id !== undefined
}

export function isCruise(item: Cruise | []): item is Cruise {
  return item !== null && (item as Cruise).cruise_id !== undefined
}
